/* eslint-disable eqeqeq */
import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  List,
  Modal,
  Popconfirm,
  Table,
  Tag,
  Typography,
} from "antd";
import React from "react";
import { connect } from "react-redux";
import * as XLSX from "xlsx/xlsx.mjs";
import { Capitalize, ConvertDateTime } from "../helper";
import { ModifyGenericTask } from "../services/ProductionPlanService";
import {
  DeleteQuoteRequest,
  GetQuoteRequests,
  UpdateQuoteRequestStatus,
} from "../services/QuoteService";

const { Text } = Typography;

const config = JSON.parse(localStorage.getItem("config") ?? "{}");
const moment = require("moment/min/moment-with-locales");
moment.locale("tr");

class QuotesScreen extends React.Component {
  configFile = JSON.parse(localStorage.getItem("config") ?? "{}");

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            width: 188,
            marginBottom: 8,
            display: "block",
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 90, marginRight: 8 }}
        >
          Bul
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          style={{ width: 90 }}
        >
          Sıfırla
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => text,
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "orange";
      case "approved":
        return "blue";
      case "rejected":
        return "red";
      case "completed":
        return "green";
      default:
        return "blue";
    }
  };

  getStatusText = (status) => {
    switch (status) {
      case "pending":
        return "Beklemede";
      case "approved":
        return "Onaylandı";
      case "rejected":
        return "Reddedildi";
      case "completed":
        return "Tamamlandı";
      default:
        return status;
    }
  };

  state = {
    csvdata: [
      [
        "İş Emri No",
        "Hedef Roller",
        "Ürün Adı",
        "Açıklama",
        "Miktar",
        "Birim",
        "Durum",
        "Oluşturulma Tarihi",
        "Notlar",
      ],
    ],
    loading: false,
    data: [],
    quotesModalVisible: false,
    selectedQuoteRequest: null,
    columns: [
      {
        title: "İş Emri No",
        dataIndex: "genericTaskId",
        sorter: (a, b) => (a.genericTaskId || 0) - (b.genericTaskId || 0),
        ...this.getColumnSearchProps("genericTaskId"),
        render: (text) => <td>{text || "-"}</td>,
      },
      {
        title: "Hedef Roller",
        dataIndex: "targets",
        sorter: (a, b) =>
          a.targets.join(", ").localeCompare(b.targets.join(", ")),
        ...this.getColumnSearchProps("targets"),
        render: (text) => (
          <td>
            {Array.isArray(text) ? (
              text.map((target, index) => (
                <Tag key={index} color="blue" style={{ margin: 2 }}>
                  {config.role?.find((role) => role.type === target)?.text ||
                    target}
                </Tag>
              ))
            ) : (
              <span>-</span>
            )}
          </td>
        ),
      },
      {
        title: "Ürün Adı",
        dataIndex: "productName",
        sorter: (a, b) => a.productName.localeCompare(b.productName),
        ...this.getColumnSearchProps("productName"),
        render: (text) => <td>{Capitalize(text)}</td>,
      },
      {
        title: "Açıklama",
        dataIndex: "description",
        sorter: (a, b) => a.description.localeCompare(b.description),
        ...this.getColumnSearchProps("description"),
        render: (text) => <td>{text ? Capitalize(text) : ""}</td>,
      },
      {
        title: "Miktar",
        dataIndex: "quantity",
        sorter: (a, b) => a.quantity - b.quantity,
      },
      {
        title: "Birim",
        dataIndex: "unit",
        sorter: (a, b) => a.unit.localeCompare(b.unit),
        ...this.getColumnSearchProps("unit"),
      },
      {
        title: "Durum",
        dataIndex: "status",
        sorter: (a, b) => a.status.localeCompare(b.status),
        render: (text) => (
          <td>
            <Tag color={this.getStatusColor(text)}>
              {this.getStatusText(text)}
            </Tag>
          </td>
        ),
      },
      {
        title: "Oluşturulma Tarihi",
        dataIndex: "createdDate",
        sorter: (a, b) =>
          moment(a.createdDate).unix() - moment(b.createdDate).unix(),
        ...this.getColumnSearchProps("createdDate"),
        render: (text) => <td>{ConvertDateTime(text)}</td>,
      },

      {
        title: "İşlemler",
        render: (text, quoteRequest) => (
          <td>
            <div style={{ display: "flex", gap: "5px" }}>
              <Button
                type="primary"
                onClick={() => this.showQuotesModal(quoteRequest)}
              >
                Teklifleri Gör
              </Button>
              {quoteRequest.status === "completed" && (
                <Button
                  type="default"
                  onClick={() =>
                    this.updateQuoteStatus(quoteRequest.id, 0, "pending")
                  }
                >
                  Yeniden Aç
                </Button>
              )}

              {this.props.user.role === "admin" ? (
                <Popconfirm
                  title="Bu teklif talebini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz."
                  onConfirm={() => {
                    DeleteQuoteRequest(quoteRequest.id).then((res) => {
                      if (res) this.GetQuoteRequests();
                    });
                  }}
                  okText="Evet"
                  cancelText="Hayır"
                >
                  <Button style={{ margin: 0 }} danger type="primary">
                    Sil
                  </Button>
                </Popconfirm>
              ) : null}
            </div>
          </td>
        ),
      },
    ],
  };

  componentDidMount() {
    this.GetQuoteRequests();
  }

  componentWillReceiveProps = (newProps, oldProps) => {
    setTimeout(() => {
      this.GetQuoteRequests();
    }, 500);
  };

  GetQuoteRequests() {
    this.setState({ loading: true });
    let csvdata = [
      [
        "İş Emri No",
        "Hedef Roller",
        "Ürün Adı",
        "Açıklama",
        "Miktar",
        "Birim",
        "Durum",
        "Oluşturulma Tarihi",
        "Notlar",
      ],
    ];

    GetQuoteRequests(this.props.isCompleted).then((data) => {
      data?.forEach((quoteRequest) => {
        quoteRequest.targetRoles = Array.isArray(quoteRequest.targets)
          ? quoteRequest.targets
              .map(
                (target) =>
                  config.role?.find((role) => role.type === target)?.text ||
                  target
              )
              .join(", ")
          : "-";

        csvdata.push([
          quoteRequest.genericTaskId || "-",
          quoteRequest.targetRoles,
          quoteRequest.productName,
          quoteRequest.description,
          quoteRequest.quantity,
          quoteRequest.unit,
          this.getStatusText(quoteRequest.status),
          ConvertDateTime(quoteRequest.createdDate),
          quoteRequest.notes,
        ]);
      });
      this.setState({ data, csvdata, loading: false });
    });
  }

  SaveExcel = (data) => {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "TeklifTalepleri.xlsx");
  };

  searchInput;

  showQuotesModal = (quoteRequest) => {
    this.setState({
      quotesModalVisible: true,
      selectedQuoteRequest: quoteRequest,
    });
  };

  hideQuotesModal = () => {
    this.setState({
      quotesModalVisible: false,
      selectedQuoteRequest: null,
    });
  };

  updateQuoteStatus = (quoteRequestId, quoteId, newStatus) => {
    UpdateQuoteRequestStatus(quoteRequestId, quoteId, newStatus).then((res) => {
      if (res) {
        // Refresh the data to show updated status
        this.GetQuoteRequests();
      }
    });
  };

  // Teklif dosyasını indir
  handleDownloadQuoteFile = (quote) => {
    if (quote.quoteFile) {
      let fileToDownload = null;

      // Eğer blob ise direkt kullan
      if (quote.quoteFile instanceof Blob) {
        fileToDownload = quote.quoteFile;
      } else if (typeof quote.quoteFile === "string") {
        // Eğer base64 string ise blob'a çevir
        try {
          // ProducerQuotesScreen.js'deki gibi data URL oluştur
          const dataUrl = quote.quoteFile.startsWith("data:")
            ? quote.quoteFile
            : `data:application/octet-stream;base64,${quote.quoteFile}`;

          fetch(dataUrl)
            .then((res) => res.blob())
            .then((blob) => {
              const url = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `teklif_dosyasi_${
                quote.creatorName
              }_${new Date().getTime()}`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
            })
            .catch((error) => {
              console.error("Dosya indirilirken hata:", error);
            });
          return;
        } catch (error) {
          console.error("Dosya indirilirken hata:", error);
          return;
        }
      }

      if (fileToDownload) {
        const url = URL.createObjectURL(fileToDownload);
        const link = document.createElement("a");
        link.href = url;
        link.download = `teklif_dosyasi_${
          quote.creatorName
        }_${new Date().getTime()}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    }
  };

  render() {
    const state = this.state;
    return (
      <>
        <Table
          pagination={{ defaultPageSize: 10, position: ["bottomRight"] }}
          rowKey={(row) => "key" + row.id}
          style={{ maxWidth: "99.5%" }}
          loading={this.state.loading}
          columns={this.state.columns}
          dataSource={state.data}
        />
        <Button
          style={styles.button}
          onClick={() => this.SaveExcel(this.state.csvdata)}
        >
          Teklif Taleplerini Excele Aktar
        </Button>
        <Modal
          title={`Teklifler - ${state.selectedQuoteRequest?.productName || ""}`}
          open={state.quotesModalVisible}
          onCancel={this.hideQuotesModal}
          footer={[
            <Button key="close" onClick={this.hideQuotesModal}>
              Kapat
            </Button>,
          ]}
          width={800}
        >
          {state.selectedQuoteRequest && (
            <div>
              {state.selectedQuoteRequest.manufacturerQuotes &&
              state.selectedQuoteRequest.manufacturerQuotes.length > 0 ? (
                <List
                  dataSource={state.selectedQuoteRequest.manufacturerQuotes}
                  renderItem={(quote, index) => (
                    <List.Item>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          gap: "5px",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div style={{ width: "100%" }}>
                          <div style={{ marginBottom: 4 }}>
                            <Text>
                              Teklif Veren:{" "}
                              {config.role?.find(
                                (role) => role.type === quote.creatorName
                              )?.text ||
                                "Belirtilmemiş (" + quote.creatorName + ")"}
                            </Text>
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <Text>
                              Fiyat:{" "}
                              {quote.fiyat
                                ? `${quote.fiyat} ${quote.kur || "TL"}`
                                : "Fiyat belirtilmemiş"}
                            </Text>
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <Text>
                              Vade:{" "}
                              {quote.vade
                                ? `${quote.vade} gün`
                                : "Belirtilmemiş"}
                            </Text>
                          </div>
                          <div style={{ marginBottom: 4 }}>
                            <Text>
                              Teslim Tarihi:{" "}
                              {quote.deliveryDate || quote.delivery_date
                                ? ConvertDateTime(
                                    quote.deliveryDate || quote.delivery_date
                                  )
                                : "Belirtilmemiş"}
                            </Text>
                          </div>
                          {quote.aciklama && (
                            <div style={{ marginBottom: 4 }}>
                              <Text>Açıklama: {quote.aciklama}</Text>
                            </div>
                          )}
                          <div>
                            <Text type="secondary">
                              Teklif Tarihi:{" "}
                              {quote.createdDate
                                ? ConvertDateTime(quote.createdDate)
                                : "Belirtilmemiş"}
                            </Text>
                          </div>
                        </div>
                        <div>
                          {quote.quoteFile && (
                            <Button
                              type="default"
                              onClick={() =>
                                this.handleDownloadQuoteFile(quote)
                              }
                              style={{ marginBottom: 8, width: "100%" }}
                            >
                              Teklifi İndir
                            </Button>
                          )}
                          {state.selectedQuoteRequest.status === "pending" && (
                            <Button
                              type="primary"
                              style={{ width: "100%" }}
                              onClick={() => {
                                this.updateQuoteStatus(
                                  state.selectedQuoteRequest.id,
                                  quote.id,
                                  "completed"
                                );
                                ModifyGenericTask({
                                  id: state.selectedQuoteRequest.genericTaskId,
                                  new_group: quote.creatorName,
                                });
                                this.hideQuotesModal();
                              }}
                            >
                              Teklifi Kabul Et
                            </Button>
                          )}
                        </div>
                        {state.selectedQuoteRequest.status === "completed" &&
                          quote.id ===
                            state.selectedQuoteRequest.acceptedQuote && (
                            <Tag color="green">Teklif Kabul Edildi</Tag>
                          )}
                      </div>
                    </List.Item>
                  )}
                />
              ) : (
                <div style={{ textAlign: "center", padding: 20 }}>
                  <Text type="secondary">
                    Bu talep için henüz teklif bulunmamaktadır.
                  </Text>
                </div>
              )}
            </div>
          )}
        </Modal>
      </>
    );
  }
}

const styles = {
  button: {
    marginLeft: 25,
    height: "40px",
    minHeight: "40px",
  },
};

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
  isCompleted: ownProps.isCompleted,
});

export default connect(mapStateToProps)(QuotesScreen);
